import { gql } from '@apollo/client';

export const COATING_COLORS = gql`
  query getAvailableCoatingColors($inputCoatingColor: String!) {
    getAvailableCoatingColors(inputCoatingColor: $inputCoatingColor)
  }
`;
